import type { FaireProductEntity } from "../../entity_types/product";

export const p_xsmtuyfey2: FaireProductEntity = {
  token: "p_xsmtuyfey2",
  type: "product",
  name: "Summer Sorbet Bracelet | Katora",
  brandToken: "b_5egcvgxh5v",
  brandName: "katora jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/739b8f5fd2b5b9d8674cce70f71f5c52bd329612116f4430169458c53d442313.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68f0d29d1663ca4b65753ba7c8ea8f495bda4de6735fadaae9e6c3e860fd1ce0.jpeg",
    "https://cdn.faire.com/fastly/e635c54f2f575eecee6270a045bc161d105254aa81710f40d7a2ca4642581a67.jpeg",
    "https://cdn.faire.com/fastly/56b70b980193c6f4c40ccf5b18ad9cd22e7b6b920215086343cbc9ead194c7a0.jpeg",
    "https://cdn.faire.com/fastly/7e7ac1b0f3d1cfb079e66d481422c6b25d600a0d5d5b1bd80e40a0996912bdf6.jpeg",
  ],
  priceDollars: 29,
  description:
    'The Summer Sorbet bracelet is a twist on your classic tennis bracelet. This is a favorite of ours and is loved by our customers. Features colorful pastel crystals that are hand-set in a beautiful ombre pattern. Easily styled with our coordinating colored studs or necklaces. This stackable bracelet is a must have.\n\n• Measures: 6.25" up to 7.5" or larger length option with 2 additonal crystals measures 7.75" up to 8"\n• Stones measure: 6 mm & 8 - 8.3 mm each\n• Available in silver finish or 14k gold plated over brass\n• Arrives in a white microfiber snap pouch with katora logo',
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:02.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
